import {useUpdateUserProfile} from 'app/hooks/profile/useUpdateUserProfile'
import {UserProfile} from 'app/modules/auth'
import {CUser} from 'app/modules/discovery/core'
import {IfeRecentAtivity} from 'interfaces/IfeFavorites'
import {useEffect} from 'react'

export const StartTracker = ({
  currentUser,
  userProfile,
}: {
  currentUser?: CUser
  userProfile?: UserProfile
}) => {
  const updateProfile = useUpdateUserProfile()

  const w: any = window

  useEffect(() => {
    const interval = setInterval(() => {
      //hook to post to profile
      const trackLayer: Array<{entity: string; id: string}> = w.dataLayer
      console.log(JSON.stringify(trackLayer))
      const uniques: Array<{entity: string; id: string}> = []
      //not most efficient but didn't get Set with Map and Array.from to work
      trackLayer?.map((item) => {
        if (!uniques.find((f) => f.entity === item.entity && f.id === item.id))
          uniques.push({entity: item.entity, id: item.id})
      })
      const profileRcentActivity: IfeRecentAtivity = {
        businesses: [
          ...new Set([
            ...(uniques.filter((f) => f.entity === 'business')?.map((m) => m.id) ?? []),
            ...(userProfile?.recent_activity?.businesses ?? []),
          ]),
        ],
        concepts: [
          ...new Set([
            ...(uniques.filter((f) => f.entity === 'concept')?.map((m) => m.id) ?? []),
            ...(userProfile?.recent_activity?.concepts ?? []),
          ]),
        ],
        people: [
          ...new Set([
            ...(uniques.filter((f) => f.entity === 'person')?.map((m) => m.id) ?? []),
            ...(userProfile?.recent_activity?.people ?? []),
          ]),
        ],
        awards: [
          ...new Set([
            ...(uniques.filter((f) => f.entity === 'award')?.map((m) => m.id) ?? []),
            ...(userProfile?.recent_activity?.awards ?? []),
          ]),
        ],
        innovations: [
          ...new Set([
            ...(uniques.filter((f) => f.entity === 'innovations')?.map((m) => m.id) ?? []),
            ...(userProfile?.recent_activity?.innovations ?? []),
          ]),
        ],
      }

      profileRcentActivity.businesses =
        profileRcentActivity.businesses?.length ?? 0 > 15
          ? profileRcentActivity.businesses?.slice(0, 15)
          : profileRcentActivity.businesses
      profileRcentActivity.concepts =
        profileRcentActivity.concepts?.length ?? 0 > 15
          ? profileRcentActivity.concepts?.slice(0, 15)
          : profileRcentActivity.concepts
      profileRcentActivity.people =
        profileRcentActivity.people?.length ?? 0 > 15
          ? profileRcentActivity.people?.slice(0, 15)
          : profileRcentActivity.people
      profileRcentActivity.awards =
        profileRcentActivity.awards?.length ?? 0 > 15
          ? profileRcentActivity.awards?.slice(0, 15)
          : profileRcentActivity.awards
      profileRcentActivity.innovations =
        profileRcentActivity.innovations?.length ?? 0 > 15
          ? profileRcentActivity.innovations?.slice(0, 15)
          : profileRcentActivity.innovations

      if (currentUser && uniques.length > 0 && userProfile) {
        userProfile.recent_activity = profileRcentActivity
        try {
          updateProfile.mutateAsync({
            userId: currentUser.id,
            rel: 'user',
            profile: userProfile,
          })
        } catch (error) {
          console.warn(error)
        }
      }
    }, 90000)

    return () => clearInterval(interval)
  }, [])
}
